<div class="comparer-content">
    @if (canScrollPrev()) {
        <button
            siriusButton
            class="comparer-prev is-light"
            buttonType="secondary"
            size="large"
            iconName="caret_left"
            [attr.aria-label]="'slider.prev' | translate"
            (click)="scrollPrev()"></button>
    }

    <div class="comparer-scroll" #scrollContainer (scroll)="onScroll()">
        @for (item of resolvedItems(); track item.title) {
            <sirius-product-information [layout]="resolvedLayout()" [config]="item" [attr.aria-label]="item.title">
            </sirius-product-information>
        }
    </div>

    @if (canScrollNext()) {
        <button
            siriusButton
            class="comparer-next is-light"
            buttonType="secondary"
            size="large"
            iconName="caret_right"
            [attr.aria-label]="'slider.next' | translate"
            (click)="scrollNext()"></button>
    }
</div>

@if (isScrollable()) {
    <nav class="comparer-dots" aria-label="Product navigation">
        @for (page of pages(); track page) {
            <button
                type="button"
                class="comparer-dot"
                [class.is-active]="page === activePage()"
                [attr.aria-label]="'slider.ariaLabel' | translate: { index: page + 1 }"
                [attr.aria-current]="page === activePage() ? 'true' : null"
                (click)="scrollToPage(page)"></button>
        }
    </nav>
}
